import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-obfuscate-value',
  templateUrl: './obfuscate-value.component.html',
  styleUrls: ['./obfuscate-value.component.scss'],
  standalone: false,
})
export class ObfuscateValueComponent implements OnInit {
  @Input() secretValue: string;
  isRevealed = false;
  displayValue: string = '';

  ngOnInit(): void {
    if (this.secretValue) {
      this.displayValue = this.secretValue.slice(0, 4) + '-✱✱✱✱-✱✱✱✱-✱✱✱✱';
    }
  }
}
